export const chatStore = {
  totalUnreadCount: 0,

  // Unsent composer content per conversation id: the HTML and mention map the
  // composer restores, plus the previewText the list shows as "Draft: ...".
  drafts: {},

  draftPreview(conversationId) {
    return this.drafts[conversationId]?.previewText ?? '';
  },

  setDraft(conversationId, draft) {
    if (draft) {
      this.drafts[conversationId] = draft;
    } else {
      delete this.drafts[conversationId];
    }
  },

  // Single client-side source of truth for other users' online state, keyed by
  // user id. Seeded from the `online` fields in serialized payloads on load and
  // patched on each PresenceChannel broadcast. The current user's own status is
  // driven by their preference, not this map.
  presence: {},

  setPresence(userId, online) {
    this.presence[userId] = online;
  },

  // Single client-side source of truth for other users' chat status label, keyed
  // by user id. Seeded from the `chat_status` fields in serialized payloads on
  // load and patched on each PresenceChannel status broadcast.
  chatStatus: {},

  setChatStatus(userId, label) {
    this.chatStatus[userId] = label;
  },
};